<script>
import { mapActions, mapGetters } from 'vuex';
import { iModal, openModal } from '@inscribe/signal';

export default {
  components: {
    iModal,
  },
  props: {
    ruleToBeDeleted: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['getRules']),
  },
  watch: {
    ruleToBeDeleted(value) {
      if (value) {
        openModal('delete-rule-modal');
      }
    },
  },

  methods: {
    ...mapActions(['updateConfigRules']),
    ...mapGetters(['getRuleIndex']),
    onClose() {
      this.$emit('on-close');
    },
    onSubmit() {
      const foundRuleIdx = this.getRuleIndex()(this.ruleToBeDeleted);
      if (foundRuleIdx > -1) {
        const newRulesCollection = [
          ...this.getRules.slice(0, foundRuleIdx),
          ...this.getRules.slice(foundRuleIdx + 1),
        ];
        this.$emit('on-delete', newRulesCollection);
      }
    },
  },
};
</script>

<template>
  <div class="wrapper">
    <i-modal
      modal-id="delete-rule-modal"
      data-testid="delete-rule-modal"
      title="Delete Fraud Rule"
      confirm-button-text="Delete"
      type="error"
      @on-submit="onSubmit"
      @on-close="onClose"
    >
      <div slot="body-content">
        Are you sure you want to delete this fraud rule?
      </div>
    </i-modal>
  </div>
</template>
